
import ReusableFormComponent from '../../components/customizedStandardsComponent/EsgFormComponent';

const GriFormComponent = (props) => {
  const { onNext, onPrevious } = props;

  return (
    <ReusableFormComponent
      {...props}
      onNext={onNext}
      onPrevious={onPrevious}
      showPreviousButton={true}
    />
  );
};

export default GriFormComponent